export type ITokenMatches = Record<string, { rule: string; property: keyof CSSStyleDeclaration }>;

const tokensMatches: ITokenMatches = {
	backgroundColorStage: {
		rule: 'body.ccp-frame, body.sid-aps',
		property: 'backgroundColor'
	},
	colorPrimary: {
		//Brand color
		rule: '.btn-link, a',
		property: 'color'
	},
	colorSuccess: {
		rule: '.label-success',
		property: 'backgroundColor'
	},
	colorWarning: {
		rule: '.label-warning',
		property: 'backgroundColor'
	},
	colorDanger: {
		rule: '.label-danger',
		property: 'backgroundColor'
	},
	colorBackgroundDisabled: {
		rule: '.btn-info',
		property: 'backgroundColor'
	},
	colorBackgroundContainer: {
		rule: '.panel',
		property: 'backgroundColor'
	},
	colorBackgroundOverlay: {
		rule: '.modal-backdrop',
		property: 'backgroundColor'
	},
	fontFaceRegular: {
		rule: 'body',
		property: 'fontFamily'
	},
	fontFaceHeading: {
		rule: 'body',
		property: 'fontFamily'
	},
	sidebarHoverBack: {
		rule: '#ccp-sidebar.collapse #ccp-navigation li > a:hover',
		property: 'backgroundColor'
	},
	sidebarCollapsedItemActiveOnhoverBackground: {
		rule: '#ccp-sidebar.collapse #ccp-navigation li.active > a',
		property: 'backgroundColor'
	},
	sidebarBackgroundColor: {
		//1.1
		rule: '#ccp-navbar',
		property: 'backgroundColor'
	},
	sidebarExpandedItemTextColor: {
		//1.2
		rule: '#ccp-navbar .nav > li > a',
		property: 'color'
	},
	sidebarExpandedItemTextHovered: {
		//1.3
		rule: '#ccp-navbar .nav > li > a:hover, #ccp-navbar .nav > li > a:focus',
		property: 'color'
	},
	sidebarExpandedItemBackgroundColorHovered: {
		//1.4
		rule: '#ccp-navbar .nav > li > a:hover, #ccp-navbar .nav > li > a:focus',
		property: 'backgroundColor'
	},
	sidebarExpandedItemTextActiveColor: {
		//1.5
		rule: '#ccp-navbar .nav > li > a:hover, #ccp-navbar .nav > li > a:focus',
		property: 'color'
	},
	sidebarExpandedItemActiveBackgroundColor: {
		//1.6
		rule: '#ccp-navbar .nav > li.active > a, #ccp-navbar .nav > li.open > a',
		property: 'backgroundColor'
	},
	sidebarCollapsedItemTextColorHovered: {
		//1.7
		rule: '.text-default, .apsMiltiLine .fa-lg + span, .apsMiltiLine .form-control-static',
		property: 'color'
	},
	sidebarCollapsedSubitemActiveTextColor: {
		//1.8
		rule: '.btn-link, a',
		property: 'color'
	},
	sidebarCollapsedItemActiveBackgroundColor: {
		//Collapsed menu active item background 31-5-22
		rule: '#ccp-navbar .nav > li > a:hover, #ccp-navbar .nav > li > a:focus',
		property: 'backgroundColor'
	},
	sidebarCollapsedItemActiveTextColor: {
		///Collapsed menu active item color 31-5-22
		rule: '#ccp-navbar .nav > li > a:hover, #ccp-navbar .nav > li > a:focus',
		property: 'color'
	},
	// Top bar & dropdown
	topBarItemIconColor: {
		//2.3
		rule: '.btn-link, a',
		property: 'color'
	},
	topBarItemIconColorHovered: {
		//2.4
		rule: 'a:hover, a:focus',
		property: 'color'
	},
	topmenuItemRegularColor: {
		//2.5
		rule: '.text-default, .apsMiltiLine .fa-lg + span, .apsMiltiLine .form-control-static',
		property: 'color'
	},
	topmenuItemActiveColor: {
		//2.7
		rule: '.text-default, .apsMiltiLine .fa-lg + span, .apsMiltiLine .form-control-static',
		property: 'color'
	},
	switchOnBackColor: {
		//2.8
		rule: '.btn-link, a',
		property: 'color'
	},
	// Content
	impersonatedBannerBackgroundColor: {
		//3.2
		rule: '#ccp-view-impersonated',
		property: 'backgroundColor'
	},
	backgroundColorPrimary: {
		//3.3
		rule: '.btn-link, a',
		property: 'color'
	},
	colorBorderPrimary: {
		//3.4
		rule: '.btn-link, a',
		property: 'color'
	},
	colorTextPrimary: {
		//3.5
		rule: '.btn-link, a',
		property: 'color'
	},
	// Review table items
	colorBrand: {
		//1
		rule: '.btn-link, a',
		property: 'color'
	},
	colorTextBrandContrast: {
		//1
		rule: '.btn-primary',
		property: 'color'
	},
	colorBorderActive: {
		//2
		rule: '.btn-link, a',
		property: 'color'
	},
	colorTextPrimaryContrast: {
		//3
		rule: '.btn-primary',
		property: 'color'
	},
	backgroundColorPrimaryHovered: {
		//4
		rule: 'a:hover, a:focus',
		property: 'color'
	},
	colorBorderPrimaryHovered: {
		//4
		rule: 'a:hover, a:focus',
		property: 'color'
	},
	stepsStepCurrentBackgroundColor: {
		//8.1
		rule: '#ccp-sidebar-level-2.wizard li.active > a .fa-stack .fa-stack-2x',
		property: 'backgroundColor'
	},
	stepsStepCurrentBorderColor: {
		//8.1
		rule: '#ccp-sidebar-level-2.wizard li.active > a .fa-stack .fa-stack-2x',
		property: 'borderColor'
	},
	stepsStepCurrentColor: {
		//8.1
		rule: '#ccp-sidebar-level-2.wizard li.active > a .fa-stack-1x',
		property: 'color'
	},
	stepsStepFutureBackgroundColor: {
		//8.2
		rule: '#ccp-sidebar-level-2.wizard li.active ~ li > a .fa-stack .fa-stack-2x',
		property: 'backgroundColor'
	},
	stepsStepFutureBorderColor: {
		//8.2
		rule: '#ccp-sidebar-level-2.wizard li.active ~ li > a .fa-stack .fa-stack-2x',
		property: 'borderColor'
	},
	stepsStepFutureColor: {
		//8.2
		rule: '#ccp-sidebar-level-2.wizard li.active ~ li > a .fa-stack .fa-stack-2x + .fa-stack-1x',
		property: 'color'
	},
	stepsStepCompletedBackgroundColor: {
		//8.3
		rule: '#ccp-sidebar-level-2.wizard li > a .fa-stack .fa-stack-2x',
		property: 'backgroundColor'
	},
	stepsStepCompletedBorderColor: {
		//8.3
		rule: '#ccp-sidebar-level-2.wizard li > a .fa-stack .fa-stack-2x',
		property: 'borderColor'
	},
	stepsStepCompletedColor: {
		//8.3
		rule: '#ccp-sidebar-level-2.wizard li > a .fa-stack .fa-stack-1x',
		property: 'color'
	},
	colorTextBrand: {
		//11
		rule: '.btn-link, a',
		property: 'color'
	},
	buttonTextPrimaryColorHovered: {
		//13
		rule: 'a:hover, a:focus',
		property: 'color'
	},
	colorTextDefault: {
		//15
		rule: '.text-default, .apsMiltiLine .fa-lg + span, .apsMiltiLine .form-control-static',
		property: 'color'
	},
	radioSelectedSymbolBackgroundColor: {
		//19
		rule: 'a:hover, a:focus',
		property: 'color'
	},
	radioSelectedSymbolBorderColor: {
		//19
		rule: 'a:hover, a:focus',
		property: 'color'
	},
	// scss brand color overwriting
	backgroundColorBrand: {
		rule: '.btn-link, a',
		property: 'color'
	},
	buttonTextDefaultColorHovered: {
		rule: '.btn-link, a',
		property: 'color'
	},
	chartAreaBorderColor: {
		rule: '.btn-link, a',
		property: 'color'
	},
	chartAreaSelectLineColor: {
		rule: '.btn-link, a',
		property: 'color'
	},
	chartAreaSelectPointColor: {
		rule: '.btn-link, a',
		property: 'color'
	},
	chartBarColorSelected: {
		rule: '.btn-link, a',
		property: 'color'
	},
	chartColor1: {
		rule: '.btn-link, a',
		property: 'color'
	},
	colorBorderBrand: {
		rule: '.btn-link, a',
		property: 'color'
	},
	colorTextActive: {
		rule: '.btn-link, a',
		property: 'color'
	},
	menu2SubmenuItemSelectedLabelColor: {
		rule: '.btn-link, a',
		property: 'color'
	},
	notification2SidebarNtfActionColor: {
		rule: '.btn-link, a',
		property: 'color'
	},
	radioButtonstyleSelectedLabelColor: {
		rule: '.btn-link, a',
		property: 'color'
	},
	radioOutlinedSelectedBorderColor: {
		rule: '.btn-link, a',
		property: 'color'
	},
	radioTilestyleSelectedBorderColor: {
		rule: '.btn-link, a',
		property: 'color'
	},
	radioTilestyleSelectedBorderColorHovered: {
		rule: '.btn-link, a',
		property: 'color'
	},
	radioTilestyleSelectedIconColor: {
		rule: '.btn-link, a',
		property: 'color'
	},
	radioTilestyleUnselectedIconColor: {
		rule: '.btn-link, a',
		property: 'color'
	},
	sliderButtonBackgroundColor: {
		rule: '.btn-link, a',
		property: 'color'
	},
	sliderFilledColor: {
		rule: '.btn-link, a',
		property: 'color'
	},
	stepsArrowColorHovered: {
		rule: '.btn-link, a',
		property: 'color'
	},
	stepsLabelCompletedColor: {
		rule: '.btn-link, a',
		property: 'color'
	},
	stepsLabelCurrentColor: {
		rule: '.btn-link, a',
		property: 'color'
	},
	tableFilterActiveBorderColor: {
		rule: '.btn-link, a',
		property: 'color'
	},
	tabsItemLineSelectedColor: {
		rule: '.btn-link, a',
		property: 'color'
	},
	tabsItemTextSelectedColor: {
		rule: '.btn-link, a',
		property: 'color'
	},
	topmenuItemActiveColorHovered: {
		rule: '.btn-link, a',
		property: 'color'
	},
	colorBorderNeutral: {
		rule: '.btn-link, a',
		property: 'color'
	}
};

export default tokensMatches;
